import React, { useContext, useMemo } from 'react';
import { ChartPoint, DonutChart, DonutChartItem, LineChart, Serie, SpotItem } from "react-charts";
import { formatDate } from 'simple-utils/dist/date-utils';
import { CostChart } from '../account/charts/CostChart';
import { LeadChart } from '../account/charts/LeadChart';
import { formatMoney } from '../utils/money-utils';
import { AdDetailContext } from './DetailStore';
import { BreakDownReport, breakDownToDonut, getLabel, ReportType, sampleBreakdown } from './models';


function baseTooltip(item:DonutChartItem){
    return <>
        {item.label}: {item.value}
    </>
}

export function AdsCharts(){
    const {state} = useContext(AdDetailContext);
    const report = useMemo(() => {
        if(!state.report.detail?.breakdowns)
            return null;
        return breakDownToDonut(state.report.detail.breakdowns)
    }, []);

    if(!report) return null;

    return <div className='row mt-4'>
            {Object.entries(report).map(([key, value]) =>
                <div className='mb-3 col-lg' key={key}>
                    <h3>{getLabel(key as ReportType)}</h3>
                    <DonutChart className='d-flex align-items-center' data={value} height={170} width={180} radius={50} thickness={16} textRadiusOffset={70} createTooltip={baseTooltip} />
                </div>
            )}
            
        </div>
}

export function AdsDailyReportCharts(){
    const {state} = useContext(AdDetailContext);
    const account = useMemo(function(){
        return state.report.report;
    }, [state.report.report]);

    return  <div className='row mt-4'>
        <div className='col-lg mt-3'>
            <h4>Leads</h4>
            <LeadChart account={account} toolTipContainer={null} />
        </div>
        <div className='col-lg mt-3'>
            <h4>Investimento</h4>
            <CostChart account={account} toolTipContainer={null} />
        </div>
    </div>
}